import { cn } from '#app/utils/misc.tsx'
import { ImageText } from './imageText'
import { RichContent } from './richContent'
import { H3 } from './typography'

export const TastingNote = ({
	title,
	generalInfo,
	image,
	imageLeftRight,
	textContent,
}) => {
	const classes = cn('flex flex-col gap-4')
	return (
		<div className={classes}>
			<H3>{title}</H3>
			<RichContent content={generalInfo.raw} />
			<ImageText
				image={image}
				imageLeftRight={imageLeftRight}
				textContent={textContent}
			/>
		</div>
	)
}
